export { default } from './MagzterGold';
